import _ from 'lodash';

export const selectCurrentUserPermissions = state =>
  _.get(state, 'auth.me.permissions');

export const selectCurrentUser = state => state.auth.me;

export const selectForgotPasswordErrors = state =>
  _.get(state.auth, 'forgotPasswordErrors._error');

export const selectForgotPasswordSuccess = state =>
  state.auth.forgotPasswordSuccess;

export const selectForgotPasswordSetSuccess = state =>
  state.auth.forgotPasswordSetSuccess;

export const selectForgotPasswordSetErrors = state =>
  _.get(state.auth, 'forgotPasswordSetErrors._error');

export const selectForgotPasswordSetToken = state =>
  state.auth.forgotPasswordToken;

export const selectCurrentUserTeams = state =>
  _.get(state, 'auth.me.teams', []);

export const selectInactivityLogoutTimer = data =>
  _.min(
    _.get(data, 'me.teams', [])
      .filter(t => !_.isNull(t.inactivityLogoutTimer))
      .map(t => t.inactivityLogoutTimer)
  );

export const selectLogoutMessage = state => state.auth.logoutMessage;
